import { render, staticRenderFns } from "./TransferList.vue?vue&type=template&id=31636deb&scoped=true&lang=pug"
import script from "./TransferList.vue?vue&type=script&lang=js"
export * from "./TransferList.vue?vue&type=script&lang=js"
import style0 from "./TransferList.vue?vue&type=style&index=0&id=31636deb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31636deb",
  null
  
)

export default component.exports